export default function SortGlossary(data) {
    data.sort((a, b) => {
        return a.concept.localeCompare(b.concept, "fr", {sensitivity: "base"})
    })
    return data
}